import { DataService, ApiService, AuthService } from "@/service";
// import { Category, WinForm } from "@/libs";
export class PriceQuiryService {
    

    static async getCompanyList(data:any) {
        const {page,perPage, cid, companyName, levelName} = data;
        let url = levelName ? `${ApiService.ZPChainApi}/supplier/getCompanyList?page=${page||''}&perPage=${perPage||''}&cid=${cid||''}&companyName=${companyName||''}&levelName=${levelName}`
                            : `${ApiService.ZPChainApi}/supplier/getCompanyList?page=${page||''}&perPage=${perPage||''}&cid=${cid||''}&companyName=${companyName||''}`
        return await DataService.get(url);
    }

    // 询价列表 inquiry/list
    static async getInquiryList(data:any) {
        const {page,perPage, dirId, type,status } = data;
        return await DataService.get(`${ApiService.EngineerApi}/inquiry/list?page=${page||''}&perPage=${perPage||''}&dirId=${dirId||''}&type=${type}&status=${status||'-1'}`);
    }
    // 成交供应商列表数据 /inquiry/companyList
    static async getInquirycompanyListList(data:any) {
        const {page,perPage, dirId } = data;
        return await DataService.get(`${ApiService.EngineerApi}/inquiry/companyList?page=${page||''}&perPage=${perPage||''}&dirId=${dirId||''}`);
    }
    // 询价详细信息
     static async getInquiryDetail(data:any) {
        const {id } = data;
        return await DataService.get(`${ApiService.EngineerApi}/inquiry/info?id=${id}`);
    }
    //新增询价
    static async saveInquiryCreate(data:any) {
         return await DataService.post(`${ApiService.EngineerApi}/inquiry/create`, data);
    }
    // 报价成功 inquiry/succeed
    static async saveInquirySucceed(data:any) {
         return await DataService.post(`${ApiService.EngineerApi}/inquiry/succeed`, data);
    }
    // 报价详情
     static async getQuoteInfo(data:any) {
        const {id } = data;
        return await DataService.get(`${ApiService.EngineerApi}/inquiry/quoteInfo?id=${id}`);
    }
    // 供应商报价列表 inquiry/inquiryQuoteList
    static async getQuoteInfoList(data:any) {
        const {companyId,page, perPage} = data;
        return await DataService.get(`${ApiService.EngineerApi}/inquiry/inquiryQuoteList?companyId=${companyId}&page=${page||'1'}&perPage=${perPage||'1000'}`);
    }
}
 